import React from 'react'
import { Route } from 'react-router-dom'

import ResetPasswordScreen from './ResetPasswordScreen'

export default [
  <Route key='reset-password' path='/reset-password' component={ResetPasswordScreen} />
]



// WEBPACK FOOTER //
// ./src/containers/ResetPassword/routes.js